
















import { Component, Prop, Vue } from 'vue-property-decorator';
import WarehousePatchForm, { WarehousePatchFormObject } from '@/components/WarehousePatch/WarehousePatchForm.vue';
import { linesToSave } from '@/app/WarehousePatch';
import { GQL_warehousePatch, GQL_warehousePatchVariables } from '@/queries/__generated__/warehousePatch';
import Decimal from 'decimal.js-light';
import { SmartQuery } from 'vue-apollo-decorator';
import { generateUID } from '@/utils/utils';
import { GQL_updateWarehousePatch, GQL_updateWarehousePatchVariables } from '@/queries/__generated__/updateWarehousePatch';
import gql from 'graphql-tag';

const warehousePatchFragments = gql`
  fragment warehousePatchFragments on WarehousePatch {
    id
    unit {
      id
    }
    supplierUnit {
      id
      name
    }
    createdBy {
      id
      name
    }
    createdAt
    comment
    date
    warehousePatchLines {
      id
      checkpoint
      product {
        id
        firstWarehousePatch {
          id
          date
        }
        supplierUnit {
          id
          name
        }
      }
      quantity
      purchasePrice
      productNumber
      productName
    }
  },
`;

const GET_WAREHOUSE_PATCH = gql`
  query warehousePatch($id: ID!) {
    warehousePatch(id: $id) {
      ...warehousePatchFragments
    }
  },
  ${warehousePatchFragments}
`;

const UPDATE_WAREHOUSE_PATCH = gql`
  mutation updateWarehousePatch($warehousePatch: WarehousePatchUpdate!) {
    updateWarehousePatch(input: { warehousePatch: $warehousePatch }) {
      warehousePatch {
        ...warehousePatchFragments
      }
    }
  },
  ${warehousePatchFragments}
`;

@Component({
  components: {
    WarehousePatchForm,
  },
})
export default class WarehousePatchEdit extends Vue {
  private GET_WAREHOUSE_PATCH = GET_WAREHOUSE_PATCH;
  private UPDATE_WAREHOUSE_PATCH = UPDATE_WAREHOUSE_PATCH;
  @Prop({ type: String, required: true }) private warehousePatchId!: string; // comes from router

  @SmartQuery<WarehousePatchEdit, GQL_warehousePatch, GQL_warehousePatchVariables>({
    query: GET_WAREHOUSE_PATCH,
    fetchPolicy: "no-cache",
    variables() { return { id: this.warehousePatchId } },
    update(data) { return this.modifyDataForForm(data) },
  }) private warehousePatch!: WarehousePatchFormObject

  private modifyDataForForm(data: GQL_warehousePatch): WarehousePatchFormObject {
    return {
      id: data.warehousePatch!.id,
      unitId: data.warehousePatch!.unit.id,
      date: data.warehousePatch!.date,
      supplierUnitId: data.warehousePatch!.supplierUnit?.id || null,
      supplierUnitName: data.warehousePatch!.supplierUnit?.name || null,
      comment: data.warehousePatch!.comment,
      createdBy: data.warehousePatch!.createdBy.name,
      createdAt: data.warehousePatch!.createdAt,
      warehousePatchLines: data.warehousePatch!.warehousePatchLines.map(line => {
        return {
          id: line.id,
          productId: line.product.id,
          supplierUnitId: line.product.supplierUnit?.id || null,
          supplierUnitName: line.product.supplierUnit?.name || null,
          quantity: line.quantity,
          purchasePrice: line.purchasePrice,
          productName: line.productName,
          productNumber: line.productNumber,
          mustBeCheckpoint: false, // will be set by the component
          checkpoint: line.checkpoint,
          productFirstWarehousePatchId: line.product.firstWarehousePatch?.id || null,
          productFirstWarehousePatchDate: line.product.firstWarehousePatch?.date || null,
          totalPrice: new Decimal(0),
          _destroy: false,
          $_UID: generateUID(),
        };
      }),
    };
  }

  public formatDataForMutation(warehousePatch: WarehousePatchFormObject): GQL_updateWarehousePatchVariables {
    return {
        warehousePatch: {
          id: warehousePatch.id!,
          unitId: warehousePatch.unitId,
          date: warehousePatch.date,
          supplierUnitId: warehousePatch.supplierUnitId,
          comment: warehousePatch.comment,
          warehousePatchLines: linesToSave(warehousePatch.warehousePatchLines).map(line => {
            return {
              id: line.id,
              productId: line.productId,
              quantity: line.quantity,
              purchasePrice: line.purchasePrice,
              productName: line.productName,
              productNumber: line.productNumber,
              checkpoint: line.checkpoint,
              _destroy: line._destroy,
            };
          }),
      },
    };
  }

  public patchUpdated(data: GQL_updateWarehousePatch) {
    this.warehousePatch = this.modifyDataForForm(data.updateWarehousePatch!);
  }
}
